module.exports = "/_next/static/images/ro-af4f1a84366c7098101b1033a8668dac.svg";